import { Icons } from '@assets';

export interface IconProps {
    /** Icon name — from the Icons registry in assets/index.ts */
    name: keyof typeof Icons;
    /** Size in px (width = height). Default: 20 */
    size?: number;
    /** Accessible label. Empty string for decorative icons */
    alt?: string;
    /** Additional Tailwind / CSS classes */
    className?: string;
    /** Click handler */
    onClick?: () => void;
}

/**
 * Icon — renders a named SVG icon from the centralized Icons registry.
 *
 * Usage:
 *   <Icon name="eyeShow" />
 *   <Icon name="chevronLeft" size={14} className="mr-1" />
 *
 * To add a new icon:
 *   1. Drop the SVG into src/assets/icons/
 *   2. Add it to the Icons map in src/assets/index.ts
 *   3. Use it anywhere with <Icon name="yourNewIcon" />
 */
function Icon({ name, size = 20, alt = '', className = '', onClick }: IconProps) {
    return (
        <img
            src={Icons[name]}
            alt={alt}
            width={size}
            height={size}
            decoding="async"
            aria-hidden={alt === '' ? true : undefined}
            className={['select-none shrink-0', onClick ? 'cursor-pointer' : '', className]
                .filter(Boolean)
                .join(' ')}
            onClick={onClick}
        />
    );
}

export default Icon;
